import { FaShieldAlt } from "react-icons/fa";
import React from "react";

export function MoneyBackGuarantee() {
  return (
    <div className="mt-8 bg-gradient-to-br from-green-50 to-green-100 p-6 rounded-xl border border-green-200 shadow-md">
      <div className="flex items-center mb-4">
        <FaShieldAlt className="w-16 h-16 text-green-600 animate-pulse" />
        <h4 className="font-bold text-2xl text-gray-800 ml-4">
          30-Day Money-Back Guarantee
        </h4>
      </div>
      <div className="flex flex-col md:flex-row gap-6 text-sm">
        {/* Left content */}
        <div className="flex-1">
          <p className="text-gray-500 leading-relaxed mb-4">
            We're confident you'll love our service and see real results. That's
            why we offer a{" "}
            <span className="font-semibold text-gray-700">
              100% money-back guarantee
            </span>{" "}
            within 30 days of your purchase.
          </p>
          <p className="text-gray-500 leading-relaxed">
            Simply demonstrate that you've followed the program, and if you're
            not satisfied with the results, we'll process a{" "}
            <span className="font-semibold text-gray-800">full refund</span> -
            no questions asked.
          </p>
        </div>

        {/* Right content with stamp */}
        <div className="flex-shrink-0 flex items-center justify-center">
          <div className="relative w-28 h-28 transform rotate-[-12deg] transition-transform hover:rotate-0">
            <img
              src="/money-back-guarantee.png"
              alt="30 Day Money Back Guarantee"
              className="w-full h-full object-contain drop-shadow-xl"
            />
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-4 pt-4 border-t border-gray-200">
        <p className="text-sm text-gray-500">
          For more details, please read our{" "}
          <a
            href="/refund-policy"
            className="text-green-600 hover:text-green-700 underline font-medium transition-colors"
          >
            refund policy
          </a>
        </p>
      </div>
    </div>
  );
}
